import { useCarbarStore } from '@/stores/carbar'
import { useCampaignsStore } from '@/stores/campaigns'

export default defineNuxtPlugin(async (nuxtApp) => {
	const runtimeConfig = useRuntimeConfig()

	// Pass the local pinia instance to ensure absolute safe initialization context
	const carbar = useCarbarStore(nuxtApp.$pinia)
	const campaigns = useCampaignsStore(nuxtApp.$pinia)

	// Establish a serialized Nuxt state container
	const metaState = useState('site-meta-payload', () => null)

	const isListingOnly = useIsListingOnly()

	// Fetch data blocking on SSR only if it has not been serialized yet.
	// Skipped in listing-only mode: the endpoint lives on carbar-api, which is not running then.
	if (!metaState.value && !isListingOnly) {
		try {
			// Using native $fetch instead of custom composables avoids instance tracking errors entirely
			const response = await $fetch(
				`${runtimeConfig.public.API_URL}/site-meta-data`,
				{
					headers: {
						Accept: 'application/json',
					},
				}
			)

			if (response?.data) {
				metaState.value = response.data
			}
		} catch (error) {
			if (process.env.NODE_ENV === 'development') {
				console.warn('Metadata fetch warning:', error)
			}
		}
	}

	// Seed campaign payloads only. Do NOT call checkCampaignStatus here — it mutates
	// cookie-persisted Pinia fields and useCookie fails after await (lost Nuxt context).
	// Status/keys are resolved in 02-campaigns-status.client.js.
	if (metaState.value) {
		const meta = metaState.value

		carbar.vehicleCount.subscription = meta.vehicleCount?.subscription ?? 0
		carbar.vehicleCount.new = meta.vehicleCount?.new ?? 0
		carbar.vehicleCount.used = meta.vehicleCount?.used ?? 0
		carbar.disabledDates = meta.deliveryBlockOut ?? {}

		campaigns.campaigns = meta.campaign ?? {}
	} else if (isListingOnly) {
		campaigns.campaigns = campaignFallback
	}

	if (import.meta.server) {
		campaigns.isLoading = false
	}
})
